import React from 'react'
import TestRunList from './components/testRun/list/TestRunList'
import styles from './testrun.module.css'

const TestRunMain = ({ projectId }) => {
    return (
        <div className={styles.pageContainer}>
            <TestRunList projectId={projectId} />
        </div>
    )
}

export default TestRunMain
